import { render, staticRenderFns } from "./SubMenuBasicItem.vue?vue&type=template&id=50c6011e&scoped=true&"
import script from "./SubMenuBasicItem.vue?vue&type=script&lang=js&"
export * from "./SubMenuBasicItem.vue?vue&type=script&lang=js&"
import style0 from "./SubMenuBasicItem.vue?vue&type=style&index=0&id=50c6011e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c6011e",
  null
  
)

export default component.exports